module.exports = __webpack_public_path__ + "img/four2Green.ea12387b.png";